<template>
  <section class="section" id="billing">
    <div class="container">
      <h1 class="title has-text-centered is-spaced">
        {{ $t("billing.plans") }}
      </h1>

      <p v-if="stores.length === 0">
        {{ $t("billing.noStores") }}
      </p>

      <plan v-for="store in stores" :key="store._id" :store="store" />

      <plans-summary :stores="stores" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Plan from "./Plan";
import PlansSummary from "./PlansSummary";

export default {
  components: {
    Plan,
    PlansSummary
  },

  computed: {
    ...mapGetters(["stores"])
  }
};
</script>

<style scoped>
#billing {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
